namespace Matrix.Data {
    export interface AccountGroupForm {
        AccountGroupCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        DefaultSortOrder: Serenity.IntegerEditor;
        AccountList: AccountGroupAccountsEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class AccountGroupForm extends Serenity.PrefixedContext {
        static formKey = 'Data.AccountGroup';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!AccountGroupForm.init)  {
                AccountGroupForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.IntegerEditor;
                var w2 = AccountGroupAccountsEditor;
                var w3 = StaticTextBlock;
                var w4 = ReadOnlyDateTime;

                Q.initFormType(AccountGroupForm, [
                    'AccountGroupCode', w0,
                    'Name', w0,
                    'DefaultSortOrder', w1,
                    'AccountList', w2,
                    'CreatedBy', w3,
                    'CreatedWhen', w4,
                    'UpdatedBy', w3,
                    'UpdatedWhen', w4,
                    'Version', w3
                ]);
            }
        }
    }
}
